import styled from 'styled-components/macro';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
export const HeaderStyled = styled.div `
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  align-content: center;

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}

  margin-bottom: ${INDENT.sm};
  margin-top: ${INDENT.sm};

  ${ADAPTIVE.minWidth.desktop} {
    margin-bottom: ${INDENT.m};
    margin-top: ${INDENT.m};
  }
`;
